import apiRequest from './apiRequest';
import EP from './endpoints';

const parseRole = ({ id }) => ({ value: id, label: id });

export const getRoles = () => apiRequest(EP.roles).then(({ data }) => data.map(parseRole));
